import slugify from 'slugify';
import { createSelector } from 'reselect';
import { ApiDoc } from '@/types';
import { RootState } from '../reducers';

const apiDocsSelector = (state: RootState) => state.apiDocs.apiDocs;
export const selectApiDocBySlug = createSelector(
  apiDocsSelector,
  (_: RootState, group: any) => group,
  (_: RootState, __: any, slug: any) => slug,
  (apiDocs, groupSlug, apiSlug) => {
    return apiDocs.data.find(
      (doc) =>
        slugify(doc.groupName, { lower: true }) === groupSlug &&
        slugify(doc.apiName, { lower: true }) === apiSlug,
    );
  },
);

export const selectApiDocById = (apiDocs: ApiDoc[], id: string) =>
  apiDocs.find((doc) => doc.id === id);
